const pageScrollFun = function pageScrollFun() {
  const fn = function fn(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  let islock = false;

  return {
    lock() {
      if (!islock) {
        islock = true;
        document.addEventListener('touchmove', fn);
      }
    },
    unlock() {
      islock = false;
      document.removeEventListener('touchmove', fn);
    }
  };
};
const pageScroll = pageScrollFun();

// 防止页面露底
const preventShowBoundary = function preventShowBoundary(filter) {
  if (window.MT && window.MT.controlWebViewScroll) {
    window.MT.controlWebViewScroll(false);
    console.log('ios app controlWebViewScroll set no');
    return;
  }
  console.log('preventShowBoundary init');
  // 减少计算
  let flag = null;
  const eles = document.querySelectorAll(filter);
  let currentElement;
  let scaleY = -1;
  let scaleX = -1;
  let direction = '';
  let isVertical = true;

  function inNodeList(elementsList, target) {
    let isIn = false;
    elementsList.forEach((v) => {
      if (v === target) {
        isIn = true;
      }
      return false;
    });
    return isIn;
  }

  function isFilterElement(target) {
    if (!filter) {
      return false;
    }
    while (!inNodeList(eles, target)) {
      target = target.parentNode;

      if (target === null || target === document.body) {
        return false;
      }
    }
    currentElement = target;
    return true;
  }

  function isAllowMove() {
    // console.log(direction, ele.scrollTop, ele.scrollHeight);
    // console.log('============');
    // console.log(ele.scrollHeight === ele.scrollTop && direction === 'down');
    // console.log(ele.scrollHeight, ele.offsetHeight, ele.scrollTop, ele.scrollHeight - ele.offsetHeight, direction);
    // console.log(ele.scrollTop <= 0 && direction === 'up');
    // console.log('============');
    // console.log(isVertical);
    if (isVertical && currentElement && ((currentElement.scrollTop >= currentElement.scrollHeight - currentElement.offsetHeight && direction === 'down') || (currentElement.scrollTop <= 0 && direction === 'up'))) {
      return false;
    }
    return true;
  }

  // pageScroll.lock();
  function lockFn(e) {
    const isFilter = isFilterElement(e.target);
    const istb = isAllowMove();
    if (flag === (istb && isFilter) && flag !== null) {
      return;
    }
    flag = istb && isFilter;
    if (flag) {
      console.log('unlock');
      pageScroll.unlock();
    } else {
      console.log('lock');
      pageScroll.lock();
    }
  }

  document.addEventListener('touchstart', (e) => {
    scaleY = e.touches[0].pageY;
    scaleX = e.touches[0].pageX;
  }, false);
  document.addEventListener('touchmove', (e) => {
    direction = e.touches[0].pageY - scaleY <= 0 ? 'down' : 'up';
    // console.log(Math.abs(e.touches[0].pageY - scaleY), Math.abs(e.touches[0].pageX - scaleX));
    // console.log(Math.abs(e.touches[0].pageY - scaleY) - Math.abs(e.touches[0].pageX - scaleX));
    isVertical = !(Math.abs(e.touches[0].pageY - scaleY) <= Math.abs(e.touches[0].pageX - scaleX));
  }, false);
  document.addEventListener('touchstart', lockFn, false);
  document.addEventListener('touchmove', lockFn, false);

  console.log('preventShowBoundary bind...');
};

const isColor = function isColor(value) {
  const colorReg = /^#([a-fA-F0-9]){3}(([a-fA-F0-9]){3})?$/;
  const rgbaReg = /^[rR][gG][bB][aA]\(\s*((25[0-5]|2[0-4]\d|1?\d{1,2})\s*,\s*){3}\s*(\.|\d+\.)?\d+\s*\)$/;
  const rgbReg = /^[rR][gG][bB]\(\s*((25[0-5]|2[0-4]\d|1?\d{1,2})\s*,\s*){2}(25[0-5]|2[0-4]\d|1?\d{1,2})\s*\)$/;

  return colorReg.test(value) || rgbaReg.test(value) || rgbReg.test(value);
};

const getScrollview = function getScrollview(el) {
  let currentNode = el;
  while (currentNode && currentNode.tagName !== 'HTML' && currentNode.tagName !== 'BODY' && currentNode.nodeType === 1) {
    const overflowY = document.defaultView.getComputedStyle(currentNode).overflowY;
    if (overflowY === 'scroll' || overflowY === 'auto') {
      return currentNode;
    }
    currentNode = currentNode.parentNode;
  }
  return window;
};

const checkInview = function checkInview(scrollView, el) {
  const contentHeight = scrollView === window ? document.body.offsetHeight : scrollView.offsetHeight;
  const contentTop = scrollView === window ? 0 : scrollView.getBoundingClientRect().top;

  const post = el.getBoundingClientRect().top - contentTop;
  const posb = post + el.offsetHeight;

  return (post >= 0 && post < contentHeight) || (posb > 0 && posb <= contentHeight);
};

const hasClass = function hasClass(elem, cls) {
  cls = cls || '';
  let classFlag = false;
  if (cls.replace(/\s/g, '').length === 0) {
    classFlag = false;
  } else {
    classFlag = new RegExp(` ${cls} `).test(` ${elem.className} `);
  }
  return classFlag;
};

const addClass = function addClass(ele, cls) {
  if (!hasClass(ele, cls)) {
    ele.className = ele.className === '' ? cls : `${ele.className}  ${cls}`;
  }
};

const removeClass = function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    let newClass = ` ${ele.className.replace(/[\t\r\n]/g, '')} `;
    while (newClass.indexOf(` ${cls} `) >= 0) {
      newClass = newClass.replace(` ${cls} `, ' ');
    }
    ele.className = newClass.replace(/^\s+|\s+$/g, '');
  }
};

// 处理 base64
const removeBase64Header = function removeBase64Header(base64Str) {
  if (base64Str) {
    return base64Str.substr(base64Str.indexOf(',') + 1);
  }
  return '';
};

export {
  pageScroll, isColor, getScrollview, checkInview, addClass, removeClass, removeBase64Header, preventShowBoundary
};



// WEBPACK FOOTER //
// ./src/assets/utils.js